export default "__VITE_ASSET__yj40FQ1c__"